export default __webpack_public_path__ + "static/media/Pintos Home.2f285f55.jpg";